// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3avMs","colMin":"styles_colMin__L3xUK"};